import { Pipe, PipeTransform } from '@angular/core';

import { contatoSituacoes } from '../pessoa-contato-situacao';

@Pipe({
    name: 'pessoaContatoSituacaoBadge'
})
export class PessoaContatoSituacaoBadgePipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = contatoSituacoes.findIndex(situacao => situacao.id === value);
        if (index > -1) {
            return contatoSituacoes[index].badge;
        }
        return '';
    }
}
